/* eslint-disable no-magic-numbers */
export const MAX_TARGETING_LENGTH = 40
export const SLUG_ATTRIBUTE = 'data-slug'
export const TABLET_WIDTH = 728
export const DFP_ID = '1030006'
export const desktopOffsetMultiplier = 2.5
export const mobileOffsetMultiplier = 2.9
export const offsetTest = false
export const timeoutTest = false
export const DEFAULT_REFRESH_INTERVAL = 28 // seconds
export const MAX_REFRESH_RETRIES = 3
export const PENNY_PRECISION = 2
export const SLOT_RENDER_ATTR = 'data-slot-rendered'
export const DEPRECATED_BLOCKLIST_ATTR = 'data-blacklist-'
export const BLOCKLIST_ATTR = 'data-blocklist-'
export const DEPRECATED_BLOCKLIST = 'blacklist'
export const BLOCKLIST = 'blocklist'
export const ALL = 'all'
export const OUTSTREAM_FLOOR = 2.5
